module.exports = __webpack_public_path__ + "img/event.744e3eed.png";